export enum FORM_INPUT {
  SELECT_OPTION = 'selectOption',
  TEXT_FIELD = 'textField',
  SINGLE_UPLOAD_FILE = 'singleUploadFile',
  BASE_PHOTO_UPLOADER = 'basePhotoUploader',
  TEXT_AREA = 'textArea',
  DATE_PICKER = 'datePicker',
  CHECKBOX = 'checkbox',
}
